import Vue from 'vue'

import {
	COMPANY_LIST,
} from '@/constants'

export const transformSubscriptions = subscriptions => {
	console.log('---transformSubscriptions', subscriptions)
	console.log('---transformSubscriptions', typeof subscriptions)
	return _.unionBy(subscriptions.map(sub => {
		return sub;
	}), COMPANY_LIST, 'company')
}

export const successLogin = response => {
	Vue.ls.set('token', response.token);
	Vue.ls.set('userId', response.userId);
	Vue.ls.set('email', response.email);
	return true;
}

export const capitalizeFirstLetter = word =>
	word.charAt(0).toUpperCase() + word.slice(1)


// WEBPACK FOOTER //
// ./src/lib/utils.js